<proffeo-ui-dialog [title]="'company-industries.modals.create-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2 create-user-modal-container">
    <proffeo-ui-input
      [formField]="form.name"
      label="company-industries.modals.form-label-name"
      class="w-full"
    />
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      matDialogClose
      text="close"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="form().invalid() || form().submitting()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
